import { coreApi } from '$api'
import { IRosteredShiftResponse } from '$models'
import { singletonQueryClient } from '$utils'
import { Dayjs } from 'dayjs'

enum QueryKeys {
  getRosteredShifts = 'rostered-shifts',
}

/**
 * Get rostered shifts by date range. By defaul this will include any unpublished
 * shifts and cross-venue shifts. The expectation is that in the 'normal case, the
 * caller will want to see all shifts in the period, regardless of whether they're
 * published or not, and whether the team member has the current venue as their
 * payroll venue.
 * @returns an array of invoices
 */
export const getAll = async (
  startTime: Dayjs,
  endTime: Dayjs,
  rosterId?: string,
  includeDeleted?: boolean,
  includeUnpublishedShifts?: boolean,
  includeCrossVenueShifts?: boolean,
  staffMemberIds?: string[],
  filterByPayrollVenue?: boolean
): Promise<IRosteredShiftResponse[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [
      QueryKeys.getRosteredShifts,
      startTime,
      endTime,
      rosterId,
      includeDeleted,
      includeUnpublishedShifts,
      includeCrossVenueShifts,
      staffMemberIds,
      filterByPayrollVenue,
    ],
    queryFn: async ({ signal }) => {
      const rosteredShifts = await coreApi.getRosteredShifts(
        rosterId,
        startTime,
        endTime,
        includeDeleted,
        includeUnpublishedShifts,
        staffMemberIds,
        includeCrossVenueShifts,
        filterByPayrollVenue,
        signal
      )

      return rosteredShifts
    },
  })
}
